import { Nullable } from 'constants/types'

export class ComponentBase {
    private _main: HTMLElement

    protected getElement<T extends HTMLElement = HTMLElement>(
        selector: string,
        element?: Nullable<HTMLElement | Document>
    ): Nullable<T> {
        if (!element) {
            return document.querySelector<T>(selector)
        }
        return element.querySelector<T>(selector)
    }

    protected getElements<T extends HTMLElement = HTMLElement>(
        selector: string,
        element?: Nullable<HTMLElement | Document>
    ): T[] {
        let result: NodeListOf<Element>
        if (element) {
            result = element.querySelectorAll(selector)
        } else {
            result = document.querySelectorAll(selector)
        }
        if (result) {
            return [...result] as T[]
        }
        return [] as T[]
    }

    /**
     * Get the <main /> element
     */
    protected get main(): Nullable<HTMLElement> {
        if (this._main) {
            return this._main
        }

        const main = document.querySelector<HTMLElement>('main')
        if (main) {
            this._main = main
            return this._main
        }

        return
    }
}
